export const SERVER_URL = '/';